import { render, staticRenderFns } from "./ServiceButton.vue?vue&type=template&id=5b8bc568&scoped=true"
import script from "./ServiceButton.vue?vue&type=script&lang=js"
export * from "./ServiceButton.vue?vue&type=script&lang=js"
import style0 from "./ServiceButton.vue?vue&type=style&index=0&id=5b8bc568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8bc568",
  null
  
)

export default component.exports